const initialState = {
    confirmDisclaimer: false,
    subscribeNewsletter: false,
    sign: {},
};

export default initialState;
